// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Source = {
    proto: (value) => {
        return {
            value: value,
            type: "proto",
            _visit: function (visitor) {
                return FernIr.Source._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "proto":
                return visitor.proto(value.value);
            default:
                return visitor._other(value);
        }
    },
};
